<template lang="html">

    <div>


        <div class="contenedor-botones row-start">

            <button class="btn -solid-primary" @click="aceptar">{{$t('candidaturas_options.aceptar')}}</button>
            <button class="btn -skull-primary" @click="showrechazar= true">{{$t('candidaturas_options.rechazar')}}</button>

        </div>


    <div class="cover-popup -middle row-center" v-if="showrechazar">

        <div class="popup">
  
          <a @click="showrechazar= false" class="close">✕</a>
  
          <h2 class="title-pop">{{$t('candidaturas_options.motivos_rechazo')}}</h2>
          <div class="contenedor-input">
            <select v-model="idMotivo" v-validate="'required'" name="estado">
              <option value="">{{$t('candidaturas_options.selecciona_motivo')}}</option>
              <template v-for="(motivo, key) in motivos">
                <option v-if="motivo.idEstado == 17 && (motivo.idPerfil == typenumber || !!!motivo.idPerfil)" :value="motivo.idMotivo">{{motivo.descripcion}}</option>
              </template>
            </select>
            <span class='error' v-if="clicked">{{ errors.first('estado')}}</span>
          </div>
  
  
          <button class="btn -solid-primary" @click="rechazar">{{$t('candidaturas_options.rechazar_preinscripcion')}}</button>
  
        </div>
      </div>

    </div>

</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex'

    import VeeValidate from 'vee-validate';
  
    export default  {
      name: 'candidatura-options',
      props : ['url','type'],
      data(){
          return{
            showrechazar : false,
            idMotivo : '',
            clicked : false
          }
  },
  mounted() {
        this.requestMotivosRechazo()
      },
      computed: {
        ...mapGetters({
          style : 'getStyles',
          motivos : 'getmotivosRechazo'
        }),
        typenumber(){
          let type = new Number();

          type = (this.type == 'empleo') ? 1 : 2;

          return type;
        }
      },  
        methods : {
            ...mapActions(['aceptarPreinscripcion','rechazarPreinscripcion', 'requestMotivosRechazo']),
            aceptar(){
                let data = {"urlOferta" : this.url}
                this.aceptarPreinscripcion(data).then( r => {});
            },
            rechazar(){
                this.clicked = true;
                this.$validator.validateAll().then(itsOk => {
                    if (itsOk) {

                    let data = {
                        "urlOferta" : this.url,
                        'idMotivo' : this.idMotivo
                    };
            
                    this.rechazarPreinscripcion(data).then( r => {
                        this.showrechazar = false;
                    });

                    }
                });

            }
      },
      components :{
      }
    }
  </script>
<style scoped lang="scss">


.contenedor-botones{
  margin-top: 15px;
  position: relative;
  z-index: 6;
  width: 100%;
}

.btn{
  margin-right: 10px;
  margin-bottom: 10px;
}

  
  </style>


// WEBPACK FOOTER //
// src/components/views/ofertas/candidatura-options.vue